import variables from '../variables';

const common = variables.colors;

export default common;
